var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -2.97 310 310",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment",
    transform: "translate(-1100.982 -3679.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1324.125,3983.477a12.109,12.109,0,0,1-7.7-2.763l-80.593-66.3H1130.079c-15.919,0-29.1-13.262-29.1-29.569V3708.835a29.365,29.365,0,0,1,29.1-29.419h252.093c16.089,0,28.81,13.185,28.81,29.419v176.012c0,16.308-12.721,29.569-28.81,29.569h-46.19v56.946a12,12,0,0,1-6.814,10.955A11.556,11.556,0,0,1,1324.125,3983.477Zm-194.046-280.061a5.528,5.528,0,0,0-5.1,5.419v176.012c0,2.9,2.582,5.569,5.1,5.569h110.1a11.977,11.977,0,0,1,7.683,2.646l64.122,52.647v-43.4a11.949,11.949,0,0,1,12.141-11.891h58.049c2.59,0,4.81-2.772,4.81-5.569V3708.835c0-2.777-2.173-5.419-4.81-5.419Z",
    fill: "#453c5c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentPost);
export default __webpack_public_path__ + "static/media/commentPost.7ee759bdac0e7bd457b9b98c4ce6e5cc.svg";
export { ForwardRef as ReactComponent };